/* Express Checkout - added by Claude
   Add to Cart posts straight through to /checkout using Shopify's own
   return_to parameter, skipping the cart drawer and the cart page.
   To undo: delete this file and remove its script tag from layout/theme.liquid. */
(function () {
  if (window.__expressCheckoutInstalled) return;
  window.__expressCheckoutInstalled = true;

  var CHECKOUT_URL = '/checkout';

  function isAddToCart(action) {
    try {
      return /\/cart\/add(\.js)?$/.test(new URL(action || '', window.location.origin).pathname);
    } catch (e) {
      return false;
    }
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!isAddToCart(form.getAttribute('action'))) return;

      if (!form.querySelector('input[name="return_to"]')) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        input.value = CHECKOUT_URL;
        form.appendChild(input);
      }

      // Stop the theme's AJAX handler so the browser does a normal POST
      // to /cart/add. Shopify adds the item, then redirects to return_to.
      e.stopImmediatePropagation();
    },
    true
  );
})();
